<template>
    <div>
        <base-material-card :icon="resource.icon" :title="title">
            <div
                class="text-right"
                style="position: absolute; right: 10px; z-index: 10"
            >
                <calendar-filter
                    @update="(val) => update(val)"
                ></calendar-filter>
            </div>
            <v-tabs v-model="selectedTab">
                <v-tab
                    class="mr-3"
                    v-for="tab in mwsConfigurationOptions"
                    :key="tab.value"
                    @click="onClickTab(tab.value)"
                >
                    <v-icon class="mr-2">mdi-amazon</v-icon>
                    {{ tab.text }}
                </v-tab>
            </v-tabs>
            <v-tabs-items v-model="selectedTab" class="transparent">
            </v-tabs-items>
            <v-row>
                <v-col>
                    <va-list
                        resource="AdsProductReport"
                        ref="list"
                        class="ads-report-list border-e-lg"
                        :filters="filters"
                        :filter.sync="filter"
                        :sort-by.sync="sort.by"
                        :sort-desc.sync="sort.desc"
                        disable-create
                        disable-export
                    >
                        <va-data-table
                            :fields="fields"
                            disable-actions
                            disable-select
                            show-expand
                        >
                            <template v-slot:expanded-item="{ item }">
                                <json-viewer
                                    :value="item"
                                    :expand-depth="5"
                                    copyable
                                    sort
                                ></json-viewer>
                            </template>
                            <template
                                v-slot:[`field.advertisedAsin`]="{
                                    value,
                                    item,
                                }"
                            >
                                <a @click="openAsinReport(item)">{{ value }}</a>
                            </template>
                        </va-data-table>
                    </va-list>
                </v-col>
            </v-row>
            <AsinProfile
                v-model="dialog"
                :selected="selected"
                :marketplace-id="
                    this.filter ? this.filter.marketplace_id : null
                "
            ></AsinProfile>
        </base-material-card>
    </div>
</template>

<script>
import moment from "moment-timezone";
import { sourceTz } from "@/constants/Time";
import CalendarFilter from "@/components/CalendarFilter.vue";
import AsinProfile from "@/components/AsinProfile.vue";
import Export from "@/resources/cog-catalog-item/Export.vue";

export default {
    mixins: [Export],
    props: {
        resource: {
            type: Object,
        },
        mwsConfigurationId: {
            type: Number,
        },
        title: {
            type: String,
        },
        perPage: {
            type: Number,
            default: 15,
        },
    },
    components: { AsinProfile, CalendarFilter },
    computed: {
        mwsConfigurationOptions() {
            return this.$store.getters.mwsConfigurationOptions;
        },
    },
    watch: {
        mwsConfigurationId: {
            immediate: true,
            handler(newVal) {
                if (!newVal) {
                    return;
                }
                const current = this.filter["mws_configuration_id"] || [];
                if (current.includes(newVal)) {
                    return;
                }
                this.filter["mws_configuration_id"] = [newVal];
            },
        },
    },
    data() {
        return {
            entity: "AdsProductReport",
            sourceTz: sourceTz,
            dateFormat: this.$admin.options.dateFormat,
            selectedTab: 0,
            filter: {
                date_between: `${moment()
                    .startOf("month")
                    .format("YYYY-MM-DD 00:00:00")},${moment()
                    .endOf("month")
                    .format("YYYY-MM-DD 23:59:59")}`,
                mws_configuration: this.mws_configuration
                    ? [this.mws_configuration]
                    : [],
            },
            sort: {
                by: ["date"],
                desc: [true],
            },
            filters: [
                {
                    source: "advertisedAsin",
                    type: "text",
                    alwaysOn: true,
                },
                {
                    source: "profileId",
                    type: "text",
                    alwaysOn: true,
                },
                {
                    source: "mws_configuration_id",
                    type: "select",
                    alwaysOn: true,
                    hidden: true,
                    attributes: {
                        choices: this.mwsConfigurationOptions,
                        itemText: "text",
                        itemValue: "value",
                        multiple: false,
                        style: "display: none",
                    },
                },
            ],
            fields: [
                { source: "advertisedAsin", sortable: true },
                { source: "impressions", sortable: true },
                { source: "clicks", sortable: true },
                { source: "cost", sortable: true },
                { source: "sales1d", sortable: true },
                { source: "purchases1d", sortable: true },
                { source: "unitsSoldClicks1d", sortable: true },
            ],
            dialog: false,
            selected: false,
        };
    },
    methods: {
        update(value) {
            this.filter = {
                ...this.filter,
                date_between: `${value.formattedStartDate},${value.formattedEndDate}`,
            };
        },
        onClickTab(id) {
            this.filter["mws_configuration_id"] = id ? [id] : [];
        },
        findSelectedTab(tabs) {
            const { filter } = this.$route.query;
            if (!filter) {
                return;
            }
            const currentFilter = JSON.parse(filter);
            if (!currentFilter["mws_configuration_id"]) {
                return;
            }
            this.selectedTab = parseInt(
                currentFilter["mws_configuration_id"],
                10
            );
            if (!this.selectedTab) {
                return;
            }
            this.selectedTab = tabs.findIndex(
                (item) => item.value === this.selectedTab
            );
        },
        openAsinReport(item) {
            this.dialog = true;
            this.selected = {
                ...item,
                asin: item.advertisedAsin,
                image: "#",
                pics: [],
                suppliers: [],
            };
        },
    },
};
</script>

<style lang="sass">
$ads-filter-height: 120px
.ads-report-list
  border-right: 1px solid black
  > header
      height: $ads-filter-height !important
      > div
          height: $ads-filter-height !important
</style>
